export default __webpack_public_path__ + "static/media/rooms.81ac774c.svg";